import React from "react";

const Button = ({ children, variant = "primary", onClick, className = "" }) => {
  const baseClasses = "font-medium rounded-full transition-all text-center";

  const variantClasses = {
    primary: "bg-primary hover:bg-primary-dark text-white py-3 px-6",
    secondary: "bg-gray-200 hover:bg-gray-300 text-gray-800 py-3 px-6",
    outline:
      "border-2 border-primary text-primary hover:bg-primary hover:text-white py-2 px-6",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
